import { Box, Tooltip, Typography } from "@mui/material";

import { useSite } from "@/api/zero/sites";
import {
  formatSendWindowTime,
  isValidSendWindowMinute,
} from "@/features/Settings/tabs/text/sendWindow/service";
import { InfoOutlinedIcon } from "@/icons";

const SEND_WINDOW_TOOLTIP =
  "Send window times are in each recipient's local time. Messages scheduled outside this window are held and delivered when the window next opens.";

export function BroadcastSendWindowCaption({ siteId }: { siteId: string }) {
  const { data: site } = useSite(siteId);
  const start = site?.sms_send_window_start;
  const end = site?.sms_send_window_end;
  if (!isValidSendWindowMinute(start) || !isValidSendWindowMinute(end)) {
    return null;
  }
  return (
    <Typography variant="body2" color="text.secondary">
      This site&apos;s send window is{" "}
      <Tooltip title={SEND_WINDOW_TOOLTIP} arrow>
        <Box
          component="span"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 0.5,
            cursor: "help",
          }}
        >
          <Box component="span" sx={{ textDecoration: "underline dotted" }}>
            {formatSendWindowTime(start)} – {formatSendWindowTime(end)}
          </Box>
          <InfoOutlinedIcon sx={{ fontSize: 16 }} />
        </Box>
      </Tooltip>
    </Typography>
  );
}
